//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
export default {
  name: 'DisplayProductSlider',
  components: {
    TitleSection,
    SubtitleSection,
    SimpleParagraph
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      showCarousel: false,
      slideNumber: 5,
      mobile: true
    };
  },

  computed: {
    title() {
      return this.payload.primary.title[0] || {};
    },

    titleColor() {
      return this.payload.primary.title_color;
    },

    subtitle() {
      return this.payload.primary.subtitle[0] || {};
    },

    subtitleColor() {
      return this.payload.primary.subtitle_color;
    },

    paragraph() {
      return this.payload.primary.paragraph;
    },

    readMore() {
      return this.payload.primary.read_more === 'Yes';
    },

    size() {
      return this.payload.primary.size;
    },

    images() {
      return this.payload.items.map(item => {
        var small = formatPrismicImage(item.image.url, ['w_190,dpr_2']) || EMPTY_PIXEL;
        var medium = formatPrismicImage(item.image.url, ['w_380,dpr_2']) || EMPTY_PIXEL;
        var large = formatPrismicImage(item.image.url, ['w_520,dpr_2']) || EMPTY_PIXEL;
        return {
          src: large,
          srcset: "".concat(small, " 380w, ").concat(medium, " 760w, ").concat(large, " 1040w"),
          text: item.title,
          url: item.url.url || '',
          target: item.url.target,
          tracking: {
            data: {
              event_category: item.event_category,
              event_action: item.event_action,
              event_label: item.event_label
            }
          }
        };
      });
    },

    slideCount() {
      return [[320, 2.5], [768, 3.5], [1024, this.slideNumber]];
    },

    isGridWidthLayout() {
      return this.size === false;
    }

  },

  mounted() {
    this.showCarousel = true;
    this.slideNumber = this.$refs.carousel.slideCount;
    this.mobile = this.isMobile();
  },

  methods: {
    componentType(item) {
      return item.url ? 'link' : 'default';
    }

  }
};